const YouTubeVideo = () => {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        width: '100%', 
        height: '100%', 
        maxWidth: '100%', 
        padding: '10px', 
        boxSizing: 'border-box' 
      }}>
        <iframe width="560" height="315" src="https://www.youtube.com/embed/00CvmeH2aPg?si=QSvbcfVQykoxZapu" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
      </div>
    );
  };
  
  export default YouTubeVideo;
